module.exports = __webpack_public_path__ + "static/media/linkedin-white.5705cef3.svg";